import { queryOptions } from '@tanstack/react-query';
import { filesStatisticsQueryFunction } from '@/modules/Dashboard/queries/fileStaticChart/filesStatisticsQueryFunction.ts';

export const filesStaticsQueryOptions = queryOptions({
  queryKey: ['file-statics'],
  queryFn: filesStatisticsQueryFunction,
  select: (data) => ({
    ...data,
    counts: data.items.map((item) => item.count),
  }),
});
